import { render, staticRenderFns } from "./AttributeNumberColors.vue?vue&type=template&id=67618c10"
import script from "./AttributeNumberColors.vue?vue&type=script&lang=ts"
export * from "./AttributeNumberColors.vue?vue&type=script&lang=ts"
import style0 from "./AttributeNumberColors.vue?vue&type=style&index=0&id=67618c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports